module.exports = __webpack_public_path__ + "static/44-d207d6e18854d1b6a19685ca3ee5055d.png";